"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["src", "fallbackSrc", "fallbackImageWidth", "aspectRatio", "altText", "backgroundColor", "backgroundColour", "className", "objectFit", "objectPosition", "height", "width", "wrapperRef", "flipped", "lazy", "srcset", "borderRadius", "manufacturer", "showMakeVehicleFallback"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import clsx from 'clsx';
import { forwardRef, useCallback, useState } from 'react';
import { logEvent, useLoggingAgent } from '@autoguru/logs';
import { Box } from '@autoguru/overdrive';
import * as styles from './Picture.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const Picture = /*#__PURE__*/forwardRef((_ref, targetRef) => {
  let {
      src,
      fallbackSrc,
      fallbackImageWidth,
      aspectRatio,
      altText,
      backgroundColor,
      backgroundColour,
      className = '',
      objectFit,
      objectPosition,
      height,
      width,
      wrapperRef,
      flipped = false,
      lazy = true,
      srcset,
      borderRadius,
      manufacturer,
      showMakeVehicleFallback
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const agent = useLoggingAgent();
  //const imgWidth = width ? width : height ? 'auto' : '100%';
  const [imgWidth, setImgWidth] = useState(width ? width : height ? 'auto' : '100%');
  const [isUsingFallback, setIsUsingFallback] = useState(false);
  const fixedHeight = Boolean(height);
  const isPortrait = aspectRatio < 1;
  const showFallback = useCallback(e => {
    setImgWidth(fallbackImageWidth || imgWidth);
    if (e.currentTarget.getAttribute('src') === fallbackSrc) {
      logEvent({
        level: 'info',
        type: 'MISSING_MANUFACTURER_LOGO',
        category: 'Picture',
        data: {
          manufacturer: manufacturer
        }
      }, agent);
      return;
    }
    e.currentTarget.setAttribute('src', fallbackSrc);
    e.preventDefault();
    e.stopPropagation();
  }, [fallbackSrc, fallbackImageWidth, imgWidth, showMakeVehicleFallback]);
  const [imgSrc, setImgSrc] = useState(src);
  const handleError = e => {
    setImgWidth(fallbackImageWidth || imgWidth);
    if (imgSrc !== fallbackSrc) {
      setImgSrc(fallbackSrc);
      setIsUsingFallback(true);
    } else {
      showMakeVehicleFallback(false);
      showFallback(e);
    }
  };

  // @ts-ignore
  return /*#__PURE__*/_jsx(Box, {
    ref: wrapperRef,
    className: clsx(className, styles.frame, {
      [styles.flipped]: Boolean(flipped) && !isUsingFallback,
      [styles.fixedHeight]: fixedHeight
    }),
    display: fixedHeight ? 'flex' : null,
    alignItems: fixedHeight ? 'center' : null,
    justifyContent: fixedHeight ? 'center' : null,
    flexDirection: fixedHeight ? 'row' : null,
    height: fixedHeight ? 'full' : null,
    borderRadius: borderRadius,
    overflow: "hidden",
    backgroundColour: backgroundColor ? null : backgroundColour || 'gray200',
    style: {
      paddingBottom: height ? undefined : `${100 * (1 / aspectRatio)}%`,
      height,
      width: imgWidth,
      backgroundColor
    },
    children: Boolean(src) && /*#__PURE__*/_jsx("img", _objectSpread(_objectSpread({
      ref: targetRef,
      loading: lazy ? 'lazy' : void 0,
      width: aspectRatio ? 100 * aspectRatio : width,
      height: aspectRatio ? 100 : height,
      src: imgSrc
      // @ts-ignore
      ,
      aspectratio: aspectRatio,
      srcSet: srcset
    }, rest), {}, {
      alt: altText || rest.alt,
      style: {
        objectPosition,
        objectFit,
        height: objectFit && isPortrait ? 'auto' : height,
        width: objectFit && !isPortrait ? 'auto' : imgWidth
      },
      onError: fallbackSrc && showMakeVehicleFallback ? handleError : fallbackSrc ? showFallback : null
    }))
  });
});
export default Picture;